import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import useUserId from "hooks/useUserId";
import colors from "colors/color";
import edit_icon from "../../assets/img/edit_icon.svg";
import cancel_icon from "../../assets/img/cancel_icon.svg";
import { NextButton } from "components/Buttons/Buttons";
import { NewSearchButton } from "components/Buttons/Buttons";
const CancelButton = styled(Button)(({ theme }) => ({
  width: 115,
  height: 48,
  borderRadius: "10px",
  borderWidth: "1px",
  gap: "10px",
  paddingTop: "14px",
  paddingRight: "24px",
  paddingBottom: "14px",
  paddingLeft: "24px",

  border: "1px solid #FF0000",
  color: "#FF0000",
  "&:hover": {
    backgroundColor: "#FF0000",
    color: "#fff",
  },
}));
const UpdateButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#fff",
  color: "#fff",
  boxShadow: "0px 0px 13px 4px rgba(0, 0, 0, 0.1)",
  "&:hover": {
    backgroundColor: "#303f9f",
    color: "#fff",
  },
}));
const StyledTextField = styled(TextField)(({ theme, isediting }) => ({
  "& .MuiOutlinedInput-root": {
    height: 56,
    borderRadius: "10px",
    fontFamily: "Poppins",
    borderColor: "#00000033",
    backgroundColor: "#fff",
    ...(isediting === "true" && {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#e0e0e0",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #0085FF",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #0085FF",
      },
    }),
    ...(isediting === "false" && {
      backgroundColor: "#fff",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
    }),
  },
}));
const ProfileCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: "#fff",
  borderRadius: "15px",
  // boxShadow: "0 4px 50px #0000001A",
  width: "80%", // Change from fixed width to percentage
  margin: "0 auto", // Center the card horizontally
  maxWidth: "1200px", // Add maximum width for larger screens
}));
const StyledTypography = styled(Typography)(() => ({
  color: "#000",
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "14px",
}));
const StyledSelect = styled(Select)(({ theme, isediting }) => ({
  height: 56,
  fontFamily: "Poppins",
  borderRadius: "10px",
  ...(isediting === "true" && {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e0e0e0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
      borderWidth: "2px",
      boxShadow: "0px 0px 5px 0.4px #0085FF",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
      borderWidth: "2px",
      boxShadow: "0px 0px 5px 0.4px #0085FF",
    },
  }),
  ...(isediting === "false" && {
    backgroundColor: "#fff",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#00000033",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#00000033",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
  }),
  "& .MuiSelect-select": {
    padding: "16.5px 14px",
  },
}));
const StyledTextArea = styled(TextField)(({ theme, isediting }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    backgroundColor: isediting === "false" ? "#f5f5f5" : "#fff",
    ...(isediting === "true" && {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#e0e0e0",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #0085FF",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #0085FF",
      },
    }),
    ...(isediting === "false" && {
      backgroundColor: "#fff",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
    }),
    "&.Mui-disabled": {
      backgroundColor: "#fff",
    },
  },
  "& .MuiInputBase-inputMultiline": {
    padding: "16px",
    lineHeight: "1.5",
    fontSize: "1rem",
    color: "#333",
  },
}));

const StyledDatePicker = styled(DatePicker)(({ theme, isediting }) => ({
  "& .MuiOutlinedInput-root": {
    height: 56,
    borderRadius: "10px",
    fontFamily: "Poppins",
    ...(isediting === "true" && {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#e0e0e0",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #0085FF",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
        borderWidth: "2px",
        boxShadow: "0px 0px 5px 0.4px #0085FF",
      },
    }),
    ...(isediting === "false" && {
      backgroundColor: "#fff",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00000033",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
    }),
  },
}));

function PersonalBiography({ formData, setFormData }) {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const userId = useUserId();
  const [isEditingBio, setIsEditingBio] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };
  useEffect(() => {
    console.log("formData", formData);
  }, [formData]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleDateChange = (newValue) => {
    const validatedDate = newValue && dayjs.isDayjs(newValue) ? newValue : null;

    setFormData((prev) => ({
      ...prev,
      dateOfBirth: validatedDate,
    }));
  };
  const handleEdit = () => setIsEditing(true);
  const handleSubmit = async (e, type = "profile") => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}candidates/${userId.userId}/update/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify({
            company: formData.company || null,
            email: formData.email || null,
            first_name: formData.firstName || null,
            last_name: formData.lastName || null,
            address: formData.address || null,
            city: formData.city || null,
            country: formData.country || null,
            postal_code: formData.postalCode || null,
            date_of_birth: formData.dateOfBirth
              ? formData.dateOfBirth.format("YYYY-MM-DD")
              : null,
            family_status: formData.familyStatus || null,
            academic_degree: formData.academicDegree || null,
            field_of_study: formData.fieldOfStudy || null,
            last_post_occupied: formData.lastPostOccupied || null,
            linkedin_profile: formData.linkedInProfile || null,
            image: formData.image || null,
            biography: formData.biography || null,
          }),
        }
      );

      if (response.ok) {
        // Handle different success cases based on type
        if (type === "biography") {
          showNotification("Biography updated successfully");
          setIsEditingBio(false);
        } else {
          showNotification("Profile updated successfully");
          setIsEditing(false);
        }
      } else {
        throw new Error("Update failed");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      showNotification("Error updating profile", "error");
    } finally {
      setLoading(false);
    }
  };
  const showNotification = (message, severity = "success") => {
    setAlertMessage(message);
    setSeverity(severity);
    showSnackbar(message);
  };
  return (
    <div>
      {" "}
      <ProfileCard elevation={0}>
        {/* Profile Header */}

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-between",
            mb: 4,
            mt: 4,
            // mx:5
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: "32px",
              color: colors.primary,
              textTransform: "none",
            }}
          >
            {t("personalInformation.profile_biography")}
          </Typography>

          <Button
            variant="outlined"
            onClick={handleEdit}
            disabled={isEditing}
            sx={{
              width: 135,
              height: 48,
              borderRadius: "10px",
              gap: "10px",
              paddingTop: "14px",
              paddingRight: "20px",
              paddingBottom: "14px",
              paddingLeft: "20px",
              backgroundColor: colors.primary,
              "&:hover": {
                border: "none",
                backgroundColor: "rgba(26, 35, 126, 0.04)",
                "& .MuiTypography-root": {
                  color: colors.primary,
                },
                "& img": {
                  filter: `brightness(0) saturate(100%) invert(23%) sepia(74%) saturate(1982%) hue-rotate(220deg) brightness(93%) contrast(98%)`,
                },
              },
              "&.Mui-disabled": {
                bgcolor: "#e0e0e0",
              },
            }}
          >
            <img src={edit_icon} />
            <Typography
              sx={{
                paddingLeft: 0,
                fontFamily: "Poppins",
                fontWeight: 400,
                fontSize: "12px",
                textTransform: "none",
                color: "white",
              }}
            >
              {t("personalInformation.edit")}
            </Typography>
          </Button>
        </Box>

        {/* Form Fields */}
        <Grid
          container
          columnSpacing={5}
          rowSpacing={6}
          sx={{
            pl: 5,
            pr: 5,
          }}
        >
          {Object.entries(formData)
            .filter(
              ([key]) =>
                ![
                  "firstName",
                  "email",
                  "company",
                  "lastName",
                  "address",
                  "city",
                  "country",
                  "image",
                  "academicDegree",
                  "fieldOfStudy",
                  "lastPostOccupied",
                  "linkedInProfile",
                  "dateOfBirth",
                  "postalCode",
                  "familyStatus",
                  "biography",
                ].includes(key)
            )
            .map(([key, value]) => (
              <Grid
                item
                xs={12}
                key={key}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Grid item xs={3}>
                  <StyledTypography>
                    {key.replace(/_/g, " ").charAt(0).toUpperCase() +
                      key.replace(/_/g, " ").slice(1)}{" "}
                    *{t(`personalInformation.${key}`)}
                  </StyledTypography>
                </Grid>
                <Grid item xs={9}>
                  <StyledTextField
                    fullWidth
                    name={key}
                    value={value}
                    onChange={handleInputChange}
                    disabled={!isEditing}
                    variant="outlined"
                    isediting={isEditing.toString()}
                  />
                </Grid>
              </Grid>
            ))}

          {/* Biography Field */}
          <Grid
            item
            xs={12}
            spacing={5}
            sx={{ display: "flex", alignItems: "flex-start", gap: 8 }}
          >
            <Grid item xs={3}>
              <StyledTypography>
                {t("personalInformation.biography")}
              </StyledTypography>
            </Grid>
            <Grid item xs={4}>
              <StyledTextArea
                fullWidth
                multiline
                rows={6}
                name="biography"
                value={formData.biography}
                onChange={handleInputChange}
                disabled={!isEditingBio}
                placeholder={t("personalInformation.biography_placeholder")}
                variant="outlined"
                isediting={isEditingBio.toString()}
              />
            </Grid>
          </Grid>

          {/* Academic Degree *
                {/* <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Grid item xs={3}>
                        <StyledTypography>
                            {t("personalInformation.academic_degree")}
                        </StyledTypography>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl fullWidth>
                            <StyledSelect
                                disabled={!isEditing}
                                id="academicDegree"
                                name="academicDegree"
                                value={formData.academicDegree}
                                onChange={handleInputChange}
                                isediting={isEditing.toString()}
                            >
                                <MenuItem value="baccalaureat">Baccalauréat</MenuItem>
                                <MenuItem value="deug">DEUG</MenuItem>
                                <MenuItem value="licence">Licence</MenuItem>
                                <MenuItem value="master">Master</MenuItem>
                                <MenuItem value="doctorat">Doctorat</MenuItem>
                                <MenuItem value="ingenieur">Diplôme d'Ingénieur</MenuItem>
                                <MenuItem value="dut">DUT</MenuItem>
                                <MenuItem value="bts">BTS</MenuItem>
                                <MenuItem value="other">Other</MenuItem>
                            </StyledSelect>
                        </FormControl>
                    </Grid>
                </Grid>

                {/* Last Post Occupied *
                <Grid item xs={12} spacing={5} sx={{ display: 'flex', alignItems: 'center', gap: 8  }}>
                    <Grid item xs={3}>
                        <StyledTypography>
                            {t("personalInformation.last_post_occupied")}
                        </StyledTypography>
                    </Grid>
                    <Grid item xs={4}>
                        <StyledTextField
                            disabled={!isEditing}
                            fullWidth
                            required
                            id="lastPostOccupied"
                            name="lastPostOccupied"
                            value={formData.lastPostOccupied}
                            onChange={handleInputChange}
                            isediting={isEditing.toString()}
                        />
                    </Grid>
                </Grid>

                {/* LinkedIn Profile *
                <Grid item xs={12} spacing={5} sx={{ display: 'flex', alignItems: 'center', gap: 8  }}>
                    <Grid item xs={3}>
                        <StyledTypography>
                            {t("personalInformation.linkedin_profile")}
                        </StyledTypography>
                    </Grid>
                    <Grid item xs={4}>
                        <StyledTextField
                            disabled={!isEditing}
                            fullWidth
                            id="linkedInProfile"
                            name="linkedInProfile"
                            value={formData.linkedInProfile}
                            onChange={handleInputChange}
                            isediting={isEditing.toString()}
                        />
                    </Grid>
                </Grid>

                {/* Family Status *
                <Grid item xs={12} spacing={5} sx={{ display: 'flex', alignItems: 'center', gap: 8  }}>
                    <Grid item xs={3}>
                        <StyledTypography>
                            {t("personalInformation.family_status")}
                        </StyledTypography>
                    </Grid>
                    <Grid item xs={4}>
                        <StyledTextField
                            disabled={!isEditing}
                            fullWidth
                            id="familyStatus"
                            name="familyStatus"
                            value={formData.familyStatus}
                            onChange={handleInputChange}
                            isediting={isEditing.toString()}
                        />
                    </Grid>
                </Grid> */}
        </Grid>

        {/* <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
          <Grid item xs={3}>
            <StyledTypography>
              {t(`personalInformation.resume`)}
            </StyledTypography>
          </Grid>
          <Grid item xs={9}>

          </Grid>
        </Grid> */}
        {/* Update Button */} 
        {isEditing ? (
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
          >
            <NewSearchButton
              variant="contained"
              onClick={(e) => handleSubmit(e, "profile")}
              disabled={!isEditing || loading}
              // sx={{
              //     bgcolor: "#fff",
              //     color: "#004F98",
              //     borderRadius: "10px",
              //     textTransform: "none",
              //     fontFamily: "Poppins",
              //     px: 4,
              //     px: 2,
              //     py: 1,
              //     fontWeight: "500px",
              //     "&:hover": {
              //         bgcolor: "#0085FF",
              //     },
              //     "&.Mui-disabled": {
              //         bgcolor: "#e0e0e0",
              //     },
              // }}
            >
              {loading ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={20} color="inherit" />
                  <span>{t("personalInformation.updating")}</span>
                </Box>
              ) : (
                t("personalInformation.update_profile")
              )}
            </NewSearchButton>
            <CancelButton
              variant="contained"
              onClick={(e) => handleSubmit(e, "profile")}
              disabled={!isEditing || loading}
              sx={{
                bgcolor: "#fff",
                color: "#004F98",
                borderRadius: "10px",
                textTransform: "none",
                fontFamily: "Poppins",
                px: 2,
                py: 1,
                fontWeight: "500",
                "&:hover": {
                  bgcolor: "#FF0000",
                  "& .MuiTypography-root": {
                    color: "#FFFFFF",
                  },
                  "& img": {
                    filter: "brightness(0) invert(1)",
                  },
                },
                "&.Mui-disabled": {
                  bgcolor: "#e0e0e0",
                },
                "& .MuiTypography-root": {
                  color: "#FF0000",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "12px",
                },
              }}
            >
              {loading ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={20} color="inherit" />
                  <span>{t("personalInformation.updating")}</span>
                </Box>
              ) : (
                <>
                  <img src={cancel_icon} alt="Cancel" />
                  <Typography>Cancel</Typography>
                </>
              )}
            </CancelButton>
          </Box>
        ) : null}
      </ProfileCard>{" "}
    </div>
  );
}

export default PersonalBiography;
